import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC, memo, SyntheticEvent } from 'react';
import { FnButtonIconTypes } from './constants';
import { BUTTONS } from './styles';

interface Props {
  viewType?: FnButtonIconTypes;
  icon?: IconDefinition;
  text?: string;
  onClick?: (event: SyntheticEvent) => void;
  className?: string;
}

const FnButtonIcon: FC<Props> = ({
  viewType = FnButtonIconTypes.Default,
  icon,
  text = '',
  onClick,
  className = '',
}) => {
  const TypedButton = BUTTONS[viewType];

  return (
    <TypedButton type="button" onClick={(event) => onClick && onClick(event)} className={className}>
      {icon && (
        <span>
          <FontAwesomeIcon icon={icon} />
        </span>
      )}
      {text ? <span>{text}</span> : null}
    </TypedButton>
  );
};

export default memo(FnButtonIcon);
